import { Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { FormGroup, FormControl, Validators} from "@angular/forms";
import { ErrorUtil } from "src/app/_utilities/error";
import { AssetService } from 'src/app/_services/asset.service';
import {UtilServiceService} from 'src/app/_services/utilService/util-service.service';
import { UsersService } from 'src/app/_services/admin/users.service';

@Component({
  selector: "app-mark-complete-cert",
  standalone: false,
  templateUrl: "./mark-complete-cert.component.html",
  styleUrl: "./mark-complete-cert.component.scss",
})
export class MarkCompleteCertComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  data: any;
  resultOptions: any[] = [
    {
      name: "Passed",
      value: "PASSED",
    },
    {
      name: "Passed with Observations",
      value: "PASSED_WITH_OBSERVATIONS",
    },
    {
      name: "Failed",
      value: "FAILED",
    },
  ];
  markCompleteForm: FormGroup;
  attachments: any[] = [];
  @ViewChild("fileUpload", { static: false })
  fileUpload!: any;
  users: any = [];
  isUserSelected: boolean = false;
  displayUserTable: boolean = false;
  todaydate: Date = new Date();

  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef,
    private errorUtil: ErrorUtil,
    private assetServc: AssetService,
    private util: UtilServiceService,
    private bsModalServc: BsModalService,
    private userService: UsersService,
  ) {
    super();
    this.markCompleteForm = new FormGroup({
      completeDate: new FormControl(null, [Validators.required]),
      performedBy: new FormControl(null, [
        Validators.required,
        //Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z0-9\s]+$/),
      ]),
      result: new FormControl(null, [Validators.required]),
      remark: new FormControl("", [Validators.maxLength(255)]),
      report: new FormControl(""),
    });
  }

  ngOnInit(): void {
    this.markCompleteForm.patchValue({
      performedBy: this.data.createdBy//default value is creator of inspection or cert
    });
    this.getLanguageData();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  onCancelClick(): void {
    this.bsModalServc.setDismissReason("cancelled");
    this.modalRef.hide();
  }

  handleUploadError(event: any) {}

  clearUpload() {
    this.fileUpload.clear();
  }

  uploadFile($event: any, fileUploaduploader: any) {
    //maximum 5 files allwed to upload
    if (this.attachments.length < 5) {
      this.parse($event.files);
    }
  }

  parse(files: FileList): void {
    console.log(files, "files printing in parse");
    const file: File = files[0] as File;
   // const form = new FormData();

    if (
      file.type == "application/vnd.microsoft.portable-executable" ||
      file.type == "application/x-msdownload" ||
      file.type == "application/octet-stream" ||
      file.type == "application/x-dosexec" ||
      file.type == "application/x-ms-dos-executable" ||
      file.type == "application/zip" ||
      file.type.startsWith("video/")
    ) {
      //exe/zip/video file upload is not allowed
      this.errorUtil.setErrorMessage(
        400,
        null,
        "Invalid file type. Only images, and document files are allowed to upload.",
        "error",
        2000,
      );
      return;
    }

   // form.append("file", file);
    this.attachments.push(file);
    console.log(this.attachments, "attachment printing..");
    this.clearUpload();
  }

  onClickSave() {
    if (this.markCompleteForm.valid) {
      let performedByVal: any = this.markCompleteForm.get("performedBy")?.value;
      let remarkVal: string = this.markCompleteForm.get("remark")?.value;

      let payload: any = {
        recordId: this.data.id,
        completedDate: this.util.formatDateToISOString(
          this.markCompleteForm.get("completeDate")?.value,
        ),
        resultStatus: this.markCompleteForm.get("result")?.value,
        files: this.attachments,
        performedBy: performedByVal.id,
        remark: remarkVal == "" ? null : remarkVal,
      };

      let formData: any = new FormData();

      formData.append("recordId", this.data.id);
      formData.append("completedDate", payload.completedDate);
      formData.append("resultStatus", payload.resultStatus);
      formData.append("performedById", payload.performedBy);
      if (remarkVal){formData.append("remarks", payload.remark);}

      if (this.data.module == 'inspection'){
        this.assetServc.markInspectionComplete(formData).subscribe({
          next: (res: any) => {
            console.log(res, "res printing..");
            if (res.status == 200 || res.status == 201) {
              this.errorUtil.setErrorMessage(
                200,
                "Certificate (" +
                  this.data.runningNo +
                  ") has been completed successfully.",
                null,
                "success",
                5000,
              );

              let jsonObj: any = {
                reason: "cert-marked-complete",
              };
              this.modalRef.hide();
              this.bsModalServc.setDismissReason(JSON.stringify(jsonObj));
            }
          },
          error: (err: any) => {
            console.log(err, "err printing..");
            this.errorUtil.setErrorMessage(
              err.status,
              err.error ? err.error.title : null,
              err.error ? err.error.title : null,
              "error",
              2000,
            );
          },
        });
      }
      else{
        this.attachments.forEach((f) => formData.append("files", f, f.name));
        this.assetServc.markCertComplete(formData).subscribe({
          next: (res: any) => {
            console.log(res, "res printing..");
            if (res.status == 200 || res.status == 201) {
              this.errorUtil.setErrorMessage(
                200,
                "Certificate (" +
                  this.data.runningNo +
                  ") has been completed successfully.",
                null,
                "success",
                5000,
              );

              let jsonObj: any = {
                reason: "cert-marked-complete",
              };
              this.modalRef.hide();
              this.bsModalServc.setDismissReason(JSON.stringify(jsonObj));
            }
          },
          error: (err: any) => {
            console.log(err, "err printing..");
            this.errorUtil.setErrorMessage(
              err.status,
              err.error ? err.error.title : null,
              err.error ? err.error.title : null,
              "error",
              2000,
            );
          },
        });
      }
    } else {
      this.markCompleteForm.markAllAsTouched();
    }
  }

  onFileRemove(file: any, index: number) {
    this.attachments.splice(index, 1);
  }
  onvalidUser() {
    //check if the value typed in is correct and has been selected or not. If not correct, then clear the value.
    if (!this.isUserSelected) {
      this.markCompleteForm.controls["performedBy"].setValue("");
    }
  }

  gotSelectedUser(event: any) {
    var val = event.value ? event.value : event;
    this.markCompleteForm.controls["performedBy"].setValue(val);
    this.users = []; //clear the list after selected
    this.isUserSelected = true;
    this.closeUserView("user");
  }

  getUsers(event: any) {
    let query: any;
    //if the getUsers function is called in completeMethod of autocomplete
    query = event.query.replace(
      /[&\/\\#,+()$~%!.„'":*‚^_¤?<>|@ª{«»§}©®™ ]/g,
      "",
    );
    
    var k = event.originalEvent.inputType;
    if (k == "deleteContentBackward") {
      this.markCompleteForm.controls["performedBy"].setValue("");
      return;
    }

    if (query && query.length > 2) {
      var serverRequest: any = {
        startRow: 0,
        pageSize: 25,
        filterModel: null,
        sortModel: [{ colId: "id", sort: "asc" }],
      };

      this.push(
        this.userService
          .advancedSearchSetupUsers(query, true)
          .subscribe((users: any) => {
            this.users = users;
          }),
      );
    }
  }

  clearValue1(type: string) {
    if (type == "user") {
      this.markCompleteForm.controls["performedBy"].setValue("");
      this.users = [];
      this.isUserSelected = false;
    }
  }

  onUserInputChange(event: any) {
    const val = event.target.value;
    if (!val || val.trim() === "") {
      this.clearValue1("user");
      this.markCompleteForm.controls["performedBy"].setValue("");
    }
  }

  showTable1(table: string) {
    if (table == "userTable") {
      this.displayUserTable = !this.displayUserTable;
    }
  }

  closeUserView(view: string) {
    if (view == "user") {
      this.displayUserTable = false;
    }
  }
}
